import React from 'react'
import {
    CContainer,
    CRow,
} from '@coreui/react'

export const Loading = () => {
    return (
        <div className="bg-light min-vh-100 d-flex flex-row align-items-center">
            <CContainer>
                <CRow className="justify-content-center">
                    Cargando...
                </CRow>
            </CContainer>
        </div>
    )
}